module.exports = __webpack_public_path__ + "img/ai11@2x@2x.16ad3146.png";